export const appInfo = {
    name: 'MESC',
    template: 'CTWR',
    version: '2.1.2',
    revisionDate: '2018-08-24 20:54:58',
    company: 'GENERAL MOTORS'
}
